/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import auditService from '../services/auditService';

export const getAuditLogsForTeam = createAsyncThunk('audit/getAuditLogsForTeam', async ({ teamId, url, sortParam }) => {
  const auditLogs = await auditService.getAuditLogsForTeam(teamId, url, sortParam);

  return { auditLogs, url };
});

export const getAuditLogsForSuperOrganization = createAsyncThunk(
  'audit/getAuditLogsForSuperOrganization',
  async ({ superOrganizationId, url, sortParam }) => {
    const auditLogs = await auditService.getAuditLogsForSuperOrganization(superOrganizationId, url, sortParam);

    return { auditLogs, url };
  }
);

const INITIAL_STATE = {
  auditLogsTeam: [],
  auditLogsSuperOrg: [],
  isLoading: false,
  isError: false,
  errorMessage: null,
  next: null
};

const auditSlice = createSlice({
  name: 'audit',
  initialState: { ...INITIAL_STATE },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAuditLogsForTeam.fulfilled, (state, action) => {
        const { auditLogs, url } = action.payload;

        state.auditLogsTeam = state.auditLogsTeam.length > 0 && url ? [...state.auditLogsTeam, ...auditLogs.results] : auditLogs.results;
        state.next = auditLogs.next;
        state.isLoading = false;
        state.isError = false;
        state.errorMessage = null;
      })
      .addCase(getAuditLogsForTeam.pending, (state, action) => {
        const query = action.meta.arg;

        state.pendingQuery = query;
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = null;
      })
      .addCase(getAuditLogsForTeam.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload?.auditLogs;
      })
      .addCase(getAuditLogsForSuperOrganization.fulfilled, (state, action) => {
        const { auditLogs, url } = action.payload;

        state.auditLogsSuperOrg =
          state.auditLogsSuperOrg.length > 0 && url ? [...state.auditLogsSuperOrg, ...auditLogs.results] : auditLogs.results;
        state.isLoading = false;
        state.next = auditLogs.next;
        state.isError = false;
        state.errorMessage = null;
      })
      .addCase(getAuditLogsForSuperOrganization.pending, (state, action) => {
        const query = action.meta.arg;

        state.pendingQuery = query;
        state.isLoading = true;
        state.isError = false;
        state.errorMessage = null;
      })
      .addCase(getAuditLogsForSuperOrganization.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.errorMessage = action.payload?.auditLogs;
      })
      .addCase('signOutGlobally', () => ({ ...INITIAL_STATE }));
  }
});

export default auditSlice.reducer;
